import { useEffect, useState } from "react";
import axios from "axios";
import { computeHeadline, brandChannelsInRange, previousRange } from "./headlineTotals";
import { pmaxInPeriod, pmaxTotals } from "../pmax/pmaxUtils";

const get = (url) => axios.get(url).then((r) => r.data).catch(() => null);

export const usePreviousPeriod = ({ API, clientId, start, end, locationParam = "", brandChannels, pmaxRecords }) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const range = previousRange(start, end);
    setResult(null);
    if (!range || !clientId) return;
    let cancelled = false;
    const rp = `client_id=${clientId}&report_start=${range.start}&report_end=${range.end}`;
    Promise.all([
      get(`${API}/mobile-summary?${rp}${locationParam}`),
      get(`${API}/meta-summary?${rp}${locationParam}`),
      get(`${API}/social-mirror-summary?${rp}${locationParam}`),
      get(`${API}/facebook-campaign-summary?${rp}${locationParam}`),
      get(`${API}/ctv-publishers?${rp}${locationParam}`),
      get(`${API}/google-ads-summary?${rp}${locationParam}`),
      get(`${API}/appfront-summary?${rp}`),
      get(`${API}/stats/traffic-acquisition?${rp}`),
      get(`${API}/ad-metrics?${rp}${locationParam}&platform=tiktok`),
    ]).then(([mobile, meta, sm, fb, ctv, gads, af, traffic, tiktok]) => {
      if (cancelled) return;
      const tk = tiktok || [];
      const pm = pmaxTotals(pmaxInPeriod(pmaxRecords || [], range.start, range.end));
      const totals = computeHeadline({
        mobileSummary: mobile, metaSummary: meta, socialMirrorSummary: sm, facebookCampaign: fb,
        ctvPublishers: Array.isArray(ctv) ? ctv : [], googleAdsData: gads, appfrontData: af, trafficData: traffic,
        tiktokImpressions: tk.reduce((s, a) => s + (a.impressions || 0), 0),
        tiktokClicks: tk.reduce((s, a) => s + (a.clicks || 0), 0),
        pmaxImpressions: pm.impressions, pmaxClicks: pm.clicks,
        brandChannelImpressions: brandChannelsInRange(brandChannels, range.start, range.end),
      });
      setResult({ range, totals });
    });
    return () => { cancelled = true; };
  }, [API, clientId, start, end, locationParam, brandChannels, pmaxRecords]);

  return result;
};
